import { EventCardPromoted } from '@eventbrite/event-renderer';
import { MegaphoneIcon, Typography } from '@eventbrite/marmalade';
import React from 'react';
import { FormattedEvent } from '../../../../event-renderer/src/types/events';
import { PromotedEventStackEventCard } from '../PromotedEventStackEventCard';
import styles from './PromotedEventStack.module.scss';

interface PromotedEventStackProps {
    events: FormattedEvent[];
    locale: string;
    onRemoveEvent?: (eventId: string) => void;
    getTrackingContext?: (data: any) => any;
}

/**
 * Displays promoted event search results in a vertical stack layout with a header.
 *
 * @param props - The props for PromotedEventStack.
 * @param props.events - An array of FormattedEvent objects to display as promoted events.
 * @param props.locale - The locale to pass to each PromotedEventStackEventCard.
 * @returns A React element rendering the promoted events stack.
 */
const PromotedEventStack: React.FC<PromotedEventStackProps> = ({
    events,
    locale,
    onRemoveEvent,
    getTrackingContext,
}) => (
    <div
        className={styles.promotedEventStackContainer}
        data-testid="promoted-event-stack-container"
    >
        <div className={styles.header}>
            <div className={styles.titleRow}>
                <MegaphoneIcon
                    color="#161719"
                    size="medium"
                    className={styles.megaphoneIcon}
                />
                <Typography
                    variant="heading-sm"
                    as="h2"
                    className={styles.title}
                >
                    Discover something new
                </Typography>
            </div>
            <EventCardPromoted
                variant="body-md"
                className={styles.subtitle}
                isPromoted={true}
            />
        </div>
        <div className={styles.eventList}>
            {events.map((event) => (
                <div className={styles.eventCardWrapper} key={event.id}>
                    <PromotedEventStackEventCard
                        event={event}
                        locale={locale}
                        isAuthenticated={true}
                        isLazyImage={true}
                        statsigLocationString="promoted_event_stack"
                        onRemoveEvent={onRemoveEvent}
                        getTrackingContext={getTrackingContext}
                    />
                </div>
            ))}
        </div>
    </div>
);

export default PromotedEventStack;
